import { render, staticRenderFns } from "./scm-base.vue?vue&type=template&id=8eab86f0&"
import script from "./scm-base.vue?vue&type=script&lang=js&"
export * from "./scm-base.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports